"use client";

import { Button } from "@hubble/web";
import React from "react";
import { useTranslations } from "i18n";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import type { PricePageReferralCardDataType } from "types/prices";
import { FILES } from "i18n/constants";

import { Body } from "app/_components/components/Text/Body";
import { buildContentfulImageUrl } from "components/common/utils/contentful-utils";

interface ReferralCardProps {
  referralCardEntry?: PricePageReferralCardDataType;
}

const ReferralCard = ({ referralCardEntry }: ReferralCardProps) => {
  const t = useTranslations(FILES.PRICES);
  const { country, isUK, isSG } = useCountryStateCookies();

  const { countryOverride = [], ...cardEntry } = referralCardEntry || {
    titleText: "",
    ctaText: "",
    bodyText: ""
  };

  const overridedData = countryOverride.filter(
    (item) => item.fields.country === country
  );

  if (overridedData.length > 0) {
    cardEntry.titleText = overridedData[0].fields.titleText;
    cardEntry.ctaText = overridedData[0].fields.ctaText;
    cardEntry.bodyText = overridedData[0].fields.bodyText;
  }

  if (isUK) {
    return null;
  }

  if (isSG) {
    return null;
  }

  return (
    <div className="flex flex-col overflow-hidden rounded-2xl bg-[#F7F7F7] [@media(max-width:709px)]:mb-[48px] [@media(min-width:711px)]:hidden [@media(min-width:904px)]:flex">
      <img
        width={390}
        height={260}
        style={{ height: "auto", width: "100%" }}
        src={buildContentfulImageUrl(
          "6jNOe3mmraYcLklCUpDTJU/f79a9ff8ebd9d5b00a357994fb58b1b8/desktop_01.png",
          "webp",
          85
        )}
        alt="rewards card"
      />
      <div className="flex flex-col gap-[20px] px-[16px] py-[20px] [@media(max-width:709px)]:p-[24px]">
        <div>
          <Body
            size="xl"
            className="!mb-[8px] leading-[24px] font-semibold tracking-[-0.5px]"
          >
            {cardEntry.titleText}
          </Body>
          <Body size="sm" className="mt-2 leading-[20px] font-normal">
            {cardEntry.bodyText}
          </Body>
        </div>
        <div className="mt-[8px] flex w-full flex-row gap-4 [@media(max-width:710px)]:flex-col">
          <Button.Secondary
            href="https://exchange.gemini.com/register"
            target="_blank"
            className="w-full !px-0 [@media(max-width:710px)]:max-w-[140px]"
          >
            <Body size="sm" className="leading-[16px] font-semibold">
              {cardEntry.ctaText}
            </Body>
          </Button.Secondary>
          <Button.Secondary
            role="link"
            target="_blank"
            href="https://www.gemini.com/referral-club"
            className="w-full !bg-[#F9A631] text-[#F9A631] hover:bg-[rgba(1,3,4,0.12)] hover:text-[#010304] [@media(max-width:710px)]:max-w-[140px]"
          >
            <Body size="sm" className="leading-[16px] font-semibold">
              {t("learnMore")}
            </Body>
          </Button.Secondary>
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
